import { CardProps } from './Card.types';
import { Wrapper, Body } from './Card.styles';

export const Card = ({ children, isWide = false }: CardProps) => (
  <Wrapper isWide={isWide}>
    <Body>{children}</Body>
  </Wrapper>
);
